module.exports = __webpack_public_path__ + "img/drugs_methPoppersCoke.ac0cc09f.png";